.bam-stage-multi {
  height: auto;

  @include desktop() {
    margin-bottom: 7rem;
  }

  // Pause Button
  & .bam-stage-multi__pause-btn {
    position: fixed;
    z-index: 1000;
    top: 200px;
    left: 16px;

    @include tablet() {
      left: 40px;
    }

    @include desktop() {
      left: 48px;
    }

    @include from(1496px) {
      left: calc(calc(100vw - 1400px) / 2);
    }

    button {
      min-height: unset;
      height: unset;
    }

    svg {
      opacity: 0;
      width: 0;

      &.is-visible {
        opacity: 1;
        width: auto;
      }
    }
  }

  .bam-stage-multi__wrapper {
    display: grid;
    position: relative;

    overflow-x: hidden;
    scrollbar-color: transparent transparent;
    scrollbar-width: 0px;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: transparent;
      border: none;
    }

    & > .is-slide {
      &:not(.has-interferer) {
        @include desktop {
          height: 906px;
        }
      }

      grid-area: 1/-1;

      bal-stage {
        background-color: transparent !important;

        section {
          margin-bottom: 0;
        }

        bal-shape {
          transform: scaleX(0);
          transform-origin: right;
          transition: transform 0.8s ease-out;
        }
      }

      .bam-stage-large__headline-mobile {
        display: flex;
        align-items: flex-end;
      }

      .bam-stage-large__card-mobile,
      .bam-stage-large__headline-mobile {
        opacity: 0;
        transform: translate(10%, 0);
        transition: transform 1s ease-in-out, opacity 1.5s ease-in;
      }

      & bal-stage bal-stage-image {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: -100%;
        transform: translate(0, 0);
        transition: transform 1s ease-in-out;
      }

      & bal-stage-body {
        opacity: 0;
        transform: translate(10%, 0);
        transition: transform 1s ease-in, opacity 1.5s ease-in;
      }

      &.is-active {
        z-index: 100;

        bal-stage {
          bal-shape {
            transform: scaleX(1);
            transition: transform 0.8s ease-out 0.25s;
          }
        }

        .bam-stage-large__card-mobile,
        .bam-stage-large__headline-mobile {
          opacity: 1;
          transform: translate(0, 0);
        }

        & bal-stage-body {
          opacity: 1;
          transform: translate(0, 0);
        }

        bal-stage bal-stage-image {
          transform: translate(100%, 0);
        }
      }

      &.fades-out {
        z-index: unset;
        & bal-stage bal-stage-image {
          transform: translate(140%, 0);
        }

        bal-stage {
          bal-shape {
            transform-origin: left;
            transition: transform 0.6s ease-out;
            transform: scaleX(0);
          }
        }

        .bam-stage-large__card-mobile,
        .bam-stage-large__headline-mobile {
          opacity: 0;
          transform: translate(-20%, 0);
          transition: transform 1s ease-in-out, opacity 0.7s ease-in;
        }

        & bal-stage-body {
          opacity: 0;
          transform: translate(-20%, 0);
        }
      }

      // Style for print view: only content of first stage is visible
      @media print {
        &.print-view {
          z-index: 100;

          bal-stage {
            bal-shape {
              transform: scaleX(1);
              transition: transform 0.8s ease-out 0.25s;
            }
          }

          .bam-stage-large__card-mobile,
          .bam-stage-large__headline-mobile {
            opacity: 1;
            transform: translate(0, 0);
          }

          & bal-stage-body {
            opacity: 1;
            transform: translate(0, 0);
          }

          bal-stage bal-stage-image {
            transform: translate(100%, 0);
          }
        }
      }
    }
  }

  // ---------- Interferers ---------- //
  .bam-stage-multi__interferer-wrapper {
    display: grid;
    position: relative;

    @include desktop {
      height: 96px;
    }

    bam-interferer {
      grid-area: 1/-1;

      @include desktop {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
      }

      .bam-interferer__background {
        transform: scaleX(0);
        transform-origin: right;
        transition: transform 0.8s ease-out;
      }

      bal-shape {
        transform: scaleX(0);
        transform-origin: right;
        transition: transform 0.8s ease-out;
      }

      &.is-active {
        .bam-interferer__background {
          transform: scaleX(1);
          transition: transform 0.8s ease-out;
        }

        bal-shape {
          transform: scaleX(1);
          transition: transform 0.8s ease-out;
        }
      }

      &.fades-out {
        .bam-interferer__background {
          transform-origin: left;
          transition: transform 0.8s ease-out 0.3s;
          transform: scaleX(0);
        }

        bal-shape {
          transform-origin: left;
          transition: transform 0.6s ease-out 0.3;
          transform: scaleX(0);
        }
      }
    }
  }

  // ----------  Controls  ---------- //
  .bam-stage-multi__controls {
    margin-bottom: 1rem;

    @include desktop {
      position: absolute;
      bottom: 4rem;
      left: 3rem;
      display: flex;
      flex-flow: row nowrap;
      width: calc(50vw - 5rem);
      max-width: 652px;
      z-index: 200;
      margin-bottom: 2px;

      &.has-interferer {
        bottom: 6rem;
        margin-bottom: 0;
      }
    }

    // Pagination for mobile and tablet
    bal-pagination nav {
      padding-top: 0;
    }

    bal-button button {
      max-height: unset;
      // min-height: unset;
      min-height: 40px;
      padding-top: 8px !important;
      padding-bottom: 8px !important;
      border-radius: 4px 4px 0 0;

      &:disabled {
        border-color: transparent;
      }
    }

    @include from(1496px) {
      left: calc(calc(100vw - 1400px) / 2);
    }

    // Controls for small desktop view (from 1024px)
    .bam-stage-multi__control-desktop-small {
      button {
        width: 40px !important;
        height: 100%;
      }
    }

    .bam-stage-multi__control-desktop-small-indicator {
      pointer-events: none;
    }

    // Controls for large desktop view (from 1280px)
    .bam-stage-multi__control {
      display: flex;
      align-items: flex-end;
      opacity: 0.7;
      position: relative;

      button {
        transition: padding 0.5s ease-out;

        &:disabled {
          background-color: white;
          color: var(--bal-color-primary-5);
        }
      }

      &.is-active {
        opacity: 1;

        button {
          padding-top: 0.8rem !important;
          padding-bottom: 0.75rem !important;
        }

        &:before,
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          background-color: var(--bal-color-white);
          width: 9px;
          height: 9px;
          background-position: 50% 50%;
        }
        &:before {
          left: -8px;
          background: radial-gradient(circle at top left, transparent 80%, white 20%);
        }

        &:after {
          left: unset;
          right: -8px;
          background: radial-gradient(circle at top right, transparent 80%, white 20%);
        }
      }

      @include desktop {
        // max-width: calc(33.33% - 1rem)
        flex: 0 1 auto;
      }

      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }
}
